import {
  APP_SETTING_FETCH_FIGMA_DATA_BEGIN,
  APP_SETTING_FETCH_FIGMA_DATA_SUCCESS,
  APP_SETTING_FETCH_FIGMA_DATA_FAILURE,
  APP_SETTING_FETCH_FIGMA_DATA_DISMISS_ERROR,
} from './constants';
import { builderSurfaceJsonContentHeader } from '../../../common/utils/restApiHeaderUtils';
import axios from 'axios';

// Rekit uses redux-thunk for async actions by default: https://github.com/gaearon/redux-thunk
// If you prefer redux-saga, you can use rekit-plugin-redux-saga: https://github.com/supnate/rekit-plugin-redux-saga
export function fetchFigmaData(args = {}) {
  return (dispatch) => { // optionally you can have getState as the second argument
    dispatch({
      type: APP_SETTING_FETCH_FIGMA_DATA_BEGIN,
    });

    // Return a promise so that you could control UI flow without states in the store.
    // For example: after submit a form, you need to redirect the page to another when succeeds or show some errors message if fails.
    // It's hard to use state to manage it, but returning a promise allows you to easily achieve it.
    // e.g.: handleSubmit() { this.props.actions.submitForm(data).then(()=> {}).catch(() => {}); }
    const promise = new Promise((resolve, reject) => {
      const { projectId, version } = args;
      const header = builderSurfaceJsonContentHeader(projectId);
      const doRequest = axios.post(
        `${process.env.REACT_APP_BUILDER_ENGINE}v${version}/figma/get-token-detail`,
        args,
        header,
      );
      doRequest.then(
        (res) => {
          dispatch({
            type: APP_SETTING_FETCH_FIGMA_DATA_SUCCESS,
            data: res.data,
          });
          resolve(res);
        },
        // Use rejectHandler as the second argument so that render errors won't be caught.
        (err) => {
          dispatch({
            type: APP_SETTING_FETCH_FIGMA_DATA_FAILURE,
            data: { error: err },
          });
          reject(err);
        },
      );
    });

    return promise;
  };
}

// Async action saves request error by default, this method is used to dismiss the error info.
// If you don't want errors to be saved in Redux store, just ignore this method.
export function dismissFetchFigmaDataError() {
  return {
    type: APP_SETTING_FETCH_FIGMA_DATA_DISMISS_ERROR,
  };
}

export function reducer(state, action) {
  switch (action.type) {
    case APP_SETTING_FETCH_FIGMA_DATA_BEGIN:
      // Just after a request is sent
      return {
        ...state,
        fetchFigmaDataPending: true,
        fetchFigmaDataError: null,
      };

    case APP_SETTING_FETCH_FIGMA_DATA_SUCCESS:
      // The request is success
      return {
        ...state,
        fetchFigmaDataPending: false,
        fetchFigmaDataError: null,
      };

    case APP_SETTING_FETCH_FIGMA_DATA_FAILURE:
      // The request is failed
      return {
        ...state,
        fetchFigmaDataPending: false,
        fetchFigmaDataError: action.data.error,
      };

    case APP_SETTING_FETCH_FIGMA_DATA_DISMISS_ERROR:
      // Dismiss the request failure error
      return {
        ...state,
        fetchFigmaDataError: null,
      };

    default:
      return state;
  }
}
